import { useMemo } from "react";
import { useProducersQuery } from "web_myplann/Api/Portfolio/Queries/useProducersQuery";
import type {
	ClientPortfolioDomainEnum,
	ProducerResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

type ProducerOptions = {
	options: FlatRowSelectOption<string>[];
	idByName: Map<string, number>;
};

export const mapProducersToOptions = (
	producers: ProducerResponseDTO[],
): ProducerOptions => ({
	options: producers.map((producer) => ({
		value: producer.name,
		label: producer.name,
	})),
	idByName: new Map(producers.map((producer) => [producer.name, producer.id])),
});

export const useProducerOptions = (
	domain: ClientPortfolioDomainEnum,
	categoryId?: number | null,
): ProducerOptions => {
	const { data } = useProducersQuery(domain, categoryId ?? undefined);

	return useMemo(() => mapProducersToOptions(data?.data ?? []), [data]);
};
